<template>
  <div class="mt-2">
    <div class="vx-row">
      <div class="vx-col w-full mx-32 mt-4">
        <h2>{{$t("customers.label.PaymentPage")}}</h2>
        <div id="component-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { AdyenCheckout, Card } from "@adyen/adyen-web";
import "@adyen/adyen-web/styles/adyen.css";
import moment from "moment";
export default {
  data() {
    return {
      paymentMethods: [],
      cardRender: null,
    };
  },

  methods: {
    async initPayment() {
      const { email, amount, currency } = this.$route.query;
      const configuration = {
        clientKey: "test_SNRES267VRAOJOGHSMMJCUOQR4ET6RHO",
        environment: "test",
        amount: {
          value: Math.abs(amount * 1 * 100),
          currency,
        },
        locale: "en-GB",
        countryCode: "GB",
        paymentMethodsResponse: this.paymentMethods,
        onSubmit: async (state, component, actions) => {
          try {
            // Make a POST /payments request from your server.
            // const result = await makePaymentsCall(
            //   state.data,
            //   countryCode,
            //   locale,
            //   amount
            // );

            const result = await this.$store.dispatch(
              "customerActivation/makePayments",
              {
                ...state.data,
                amount: {
                  value: Math.abs(amount * 1 * 100),
                  currency,
                },
                email,
                // storePaymentMethod: true,
                shopperInteraction: "Ecommerce",
                recurringProcessingModel: "CardOnFile",
              }
            );

            // If the /payments request from your server fails, or if an unexpected error occurs.
            if (!result.data || !result.data.resultCode) {
              actions.reject();
              return;
            }

            const {
              resultCode,
              action,
              order,
              donationToken,
              merchantReference,
            } = result.data;

            // actions.resolve({
            //   resultCode,
            //   action,
            //   order,
            //   donationToken,
            // });

            if (resultCode === "Authorised") {
              const payload = {
                paymentCode: 728,
                amountPaid: (result.data.amount.value / 100)
                  .toFixed(2)
                  .toString(),
                receiptNo: merchantReference,
                remarks: "Online Payment",
                locale: "en",
                dateFormat: "dd MMMM yyyy",
                paymentDate: moment().format("DD MMMM YYYY"),
                isSubscriptionPayment: false,
              };
              await this.$store.dispatch("customerActivation/afterPayments", {
                id: this.$route.query.customerId,
                data: payload,
              });
              actions.resolve({ resultCode }); // ✅ Ensure loading stops on success
              component.setStatus("ready"); // Reset component state
              return;
            }
          } catch (error) {
            console.error("onSubmit", error);
            actions.reject();
          }
        },
        onAdditionalDetails: async (state, component, actions) => {
          try {
            // Make a POST /payments/details request from your server.
            const result = {};
            // await makeDetailsCall(state.data);
            if (!result.resultCode) {
              actions.reject();
              return;
            }

            const { resultCode, action, order, donationToken } = result;
            actions.resolve({
              resultCode,
              action,
              order,
              donationToken,
            });
          } catch (error) {
            console.error("onSubmit", error);
            actions.reject();
          }
        },
        onPaymentCompleted: async (result, component) => {
          console.info(result, component, "onPaymentCompleted");
          this.cardRender.unmount();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Payment Successful!",
            type: "success",
          });
          this.$router.push(
            `/customers/view_customer/${this.$route.query.customerId}`
          );
        },
        onPaymentFailed: (result, component) => {
          console.info(result, component, "onPaymentFailed");
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Something went wrong",
            type: "error",
          });
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
        },
      };

      const checkout = await AdyenCheckout(configuration);

      this.cardRender = new Card(checkout).mount("#component-container");
    },
    async getPaymentMethods() {
      const { amount, currency } = this.$route.query;
      try {
        this.paymentMethods = [];
        const res = await this.$store.dispatch(
          "customerActivation/fetchPaymentMethods",
          {
            amount: { value: Math.abs(amount * 1 * 100), currency },
            channel: "Web",
          }
        );
        this.paymentMethods = res.data;
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong",
          type: "error",
        });
      }
    },
  },
  async mounted() {
    await this.getPaymentMethods();
    this.initPayment();
  },
};
</script>
